module.exports = __webpack_public_path__ + "img/3_168.0da2662d.png";